/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDataExportResultFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeDataExportResult, serializeExportOrdersByIdRequest, type DataExportResult, type ErrorResponse, type ExportOrdersByIdRequest, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/exports/orders/by-id
 */
export interface ByIdRequestBuilder extends BaseRequestBuilder<ByIdRequestBuilder> {
    /**
     * Exports orders for an organization based on provided Order IDs in the requested format. Supply ExportFileType for a built-in type (CSV, Tab Delimited, JSON, SAP), or CustomFormatKey for a custom multi-file format from GET api/exports/formats. CustomFormatKey takes precedence when both are sent, and delivers the export as a zip. A key the organization has not been enabled for is rejected with a 400.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DataExportResult>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: ExportOrdersByIdRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DataExportResult | undefined>;
    /**
     * Exports orders for an organization based on provided Order IDs in the requested format. Supply ExportFileType for a built-in type (CSV, Tab Delimited, JSON, SAP), or CustomFormatKey for a custom multi-file format from GET api/exports/formats. CustomFormatKey takes precedence when both are sent, and delivers the export as a zip. A key the organization has not been enabled for is rejected with a 400.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: ExportOrdersByIdRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ByIdRequestBuilderUriTemplate = "{+baseurl}/api/exports/orders/by-id";
/**
 * Metadata for all the requests in the request builder.
 */
export const ByIdRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ByIdRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDataExportResultFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeExportOrdersByIdRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
